import { actionTextColor } from "../utils/themeContrast";
import { readableText, lightTint } from "../utils/themeContrast";
import React, { useEffect, useRef, useState } from "react";
import { VariableSizeList as List } from "react-window";
import "../styles/styles.css";
import styled from "@emotion/styled";
import { ThemeContext, UserContext, ActionContext } from "../contexts/Context";
import CategorySearch from "./CategorySearch";
import useWindowDimensions from "../hooks/useWindowDimensions";
import { navigate } from '@reach/router';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

const MenuSideBar = ({
  height,
  itemList,
  setSelectedCategory,
  selectedCategory,
  category,
  setSelectedMenu,
  otherUrls,
  unlimitedScroll,
  selectedMenu,
  setLastPos,
  sidebarWidth,
  headerHeight
}) => {
  const { width: viewportWidth } = useWindowDimensions();
  const [newList, setList] = useState([]);
  const [itemLen, setLen] = useState(0);
  useEffect(() => {
    //Stuff for List
    let newList = JSON.parse(JSON.stringify(itemList));

    newList.push({ category: "" });
    newList.push({ category: "_________" });

    if (otherUrls && otherUrls.length > 0) {
      otherUrls.forEach((ol) => {
        newList.push({ category: ol.title });
      });
    }
    newList = newList.concat({ category: "ABOUT US" });

    setList(newList);

    let itemLen = itemList.length;
    setLen(itemLen);
  }, [itemList]);


  const listRef = useRef(null);

  const rowHeight = viewportWidth >= 768 ? 50 : 56;
  const getItemSize = () => rowHeight;

  useEffect(() => {
    if (listRef.current) listRef.current.resetAfterIndex(0);
  }, [rowHeight]);

  //Context
  const { company, lanIndex, isLanReverse } = React.useContext(UserContext);
  const themeContext = React.useContext(ThemeContext);
  const { setScrolling } = React.useContext(ActionContext);

  const scrollToView = (element) => {
    //get view position
    if (element == null) return;
    let parentElement = document.getElementById("menu_scroll");
    let parentTop = 0;
    if (parentElement != null) {
      parentTop = parentElement.getBoundingClientRect().top;
    }
    let posTarget = element.getBoundingClientRect().top - parentTop + 20;
    // let margin = posTarget / 1000 * 60;
    // let i = 0;
    setScrolling(true);
    document.getElementById("menu_scroll").scrollBy({ top: posTarget });

    // function step() {
    //   document.getElementById("root").scrollBy({ top: margin });
    //   posTarget -= margin;
    //   if (i < 17 && Math.abs(posTarget) > 50) { //acceptable
    //     i++;
    //     window.requestAnimationFrame(step);
    //   } else {

    //     let offset = element.getBoundingClientRect().top - 20 - parentTop;
    //     alert("PAS TO LAST STEP " + offset +" ORIGINAL "+ posTarget + " margin "+ margin +" parent "+ parentTop);
    //     document.getElementById("root").scrollBy({ top: offset });
    window.setTimeout(() => {
      setScrolling(false);
    }, 500);

    //   }
    // }
    // window.requestAnimationFrame(step);



  }

  useEffect(() => {
    if (unlimitedScroll) {
      window.setTimeout(() => {
        scrollToView(document.getElementById(category));
      }, 50);
    }
  }, []);

  useEffect(() => {
    if (unlimitedScroll && selectedCategory) {
      let selectedIndex = 0;
      newList.forEach((nl, i) => {
        let mCat = nl.category;
        mCat = mCat.replaceAll("/", "").replaceAll("%", "");
        if (mCat == selectedCategory.category) {
          selectedIndex = i;
        }
      });

      if (newList.length > 0) {
        window.setTimeout(() => {
          if (listRef.current != null)
            listRef.current.scrollToItem(selectedIndex, 'auto');
        }, 50);

      }
    } else if (category) {
      let selectedIndex = 0;
      newList.forEach((nl, i) => {
        let mCat = nl.category;
        mCat = mCat.replaceAll("/", "").replaceAll("%", "");
        if (mCat == category) {
          selectedIndex = i;
        }
      });

      if (newList.length > 0) {
        window.setTimeout(() => {
          if (listRef.current != null)
            listRef.current.scrollToItem(selectedIndex, 'auto');
        }, 50);

      }
    }

  }, [newList, category, selectedCategory])



  return (
    <SideBarContainer themeContext={themeContext} sidebarWidth={sidebarWidth} headerHeight={headerHeight}>
      <SidebarSearch themeContext={themeContext}><CategorySearch sidebar /></SidebarSearch>
      <TransitionGroup>
        <List
          ref={listRef}
          // onScroll={scrollCheck}
          className="no-scrollbars"
          //Height of Header(80) + Title(40) + NavBar(40) = 160
          height={Math.max(0, height - headerHeight - (sidebarWidth >= 180 ? 20 : 12) - 50 - (viewportWidth >= 768 ? 66 : 50))}
          itemCount={newList.length}
          itemSize={getItemSize}
          width={sidebarWidth}
          itemData={{
            setSelectedCategory: setSelectedCategory,
            setSelectedMenu: setSelectedMenu,
            selectedCategory: selectedCategory ? selectedCategory.category : "",
            newList: newList,
            otherUrls: otherUrls,
            themeContext: themeContext,
            url: company.url,
            itemLen,
            lanIndex,
            isLanReverse,
            unlimitedScroll,
            scrollToView,
            selectedMenu,
            setScrolling,
            setLastPos,
            sidebarWidth
          }}
          overscanCount={200}
        >

          {Row}

        </List>
      </TransitionGroup>
    </SideBarContainer>
  );
};
export default React.memo(MenuSideBar);

const Row = ({ index, data, style }) => {
  //Data passed as props to List Component

  const {
    newList,
    setSelectedCategory,
    setSelectedMenu,
    selectedCategory,
    themeContext,
    url,
    itemLen,
    otherUrls,
    lanIndex,
    isLanReverse,
    unlimitedScroll,
    scrollToView,
    setLastPos,
    sidebarWidth
  } = data;

  let category = (lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ? newList[index].category : newList[index].category2 ? newList[index].category2 : newList[index].category;
  if (newList[index].isSub) {
    category = "* " + category + " *";
  }
  const inset = sidebarWidth >= 180 ? 20 : 6;
  const rowStyle = {
    ...style,
    left: inset,
    width: sidebarWidth - inset * 2 - 1,
    height: style.height - 4
  };

  return (
    <React.Fragment>
      <CSSTransition
        key={category}
        in={true}
        timeout={250}
        classNames="cat"
      // unmountOnExit
      >
        {selectedCategory == newList[index].category ?
          <CategorySelected
            style={rowStyle}
            themeContext={themeContext}
            sidebarWidth={sidebarWidth}
            textLength={newList[index].category.length}
            finalItem={newList.length}
            isSub={newList[index].isSub}
            index={index}
            onClick={() => {
              window.history.back();
            }}
          >
            {category}
          </CategorySelected>
          :
          <CategoryContainer
            style={rowStyle}
            themeContext={themeContext}
            sidebarWidth={sidebarWidth}
            isSub={newList[index].isSub}
            active={newList[index].active}
            textLength={newList[index].category.length}
            onClick={() => {
              if (index === newList.length - 1) {
                //Final Item of the list should be About Us
                //Go to company link
                window.open(url, "_blank");
              } else if (index >= itemLen) {
                if (!otherUrls) return;
                let ou = otherUrls.find((v) => v.title == newList[index].category);

                if (ou) {
                  window.open(ou.url, "_blank");
                }
              } else {

                setSelectedMenu(null);
                setSelectedCategory(newList[index]);

                let category = newList[index].category;
                if (unlimitedScroll) {
                  setLastPos(0);
                  scrollToView(document.getElementById(category));
                }
                category = category.replaceAll("/", "");
                category = category.replaceAll("%", "");
                if (!unlimitedScroll)
                  navigate('/menu/menu/' + category);
                else
                  navigate('/menu');

              }
            }}
            finalItem={newList.length}
            index={index}
          >
            {category}
          </CategoryContainer>
        }
      </CSSTransition>
    </React.Fragment >
  );
};

// Shared row spacing keeps the virtualized list aligned with its item heights.
const CategoryContainer = styled.div`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: ${props => props.sidebarWidth >= 180 ? "0 18px" : "0 6px"};
  border-radius: ${props => props.sidebarWidth >= 180 ? 12 : 10}px;
  font-family: ${props => props.themeContext.fontFamily};
  font-size: ${props => props.sidebarWidth >= 180 ? (props.isSub ? 13 : 15) : (props.isSub ? 10 : 12)}px;
  font-weight: 500;
  @media (min-width: 768px) { font-weight: 400; }
  line-height: 1.3;
  text-align: left;
  overflow-wrap: break-word;
  word-break: normal;
  hyphens: auto;
  color: ${props => readableText(props.themeContext.backgroundColor, props.themeContext.unselectedCategory, props.themeContext.fontPrimary)};
  cursor: pointer;
  transition: background-color 150ms ease, color 150ms ease;
`;

const CategorySelected = styled(CategoryContainer)`
  background-color: ${props => props.themeContext.primaryColor};
  color: ${props => actionTextColor(props.themeContext)};
  font-weight: 700;
  @media (min-width: 768px) { font-weight: 600; }
`;

const SidebarSearch = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 8px;
  @media (min-width: 768px) {
    justify-content: flex-end;
    padding: 0 20px 17px;
    margin-bottom: 0;
    border-bottom: 1px solid ${props => lightTint(props.themeContext.primaryColor, .2)};
  }
`;

const SideBarContainer = styled.div`
  position: absolute;
  top: ${(props) => props.headerHeight}px;
  bottom: 0rem;
  text-align: center;
  justify-content: center;
  align-items: center;
  width: ${(props) => props.sidebarWidth}px;
  min-width: ${(props) => props.sidebarWidth}px;
  box-sizing: border-box;
  padding-top: ${(props) => props.sidebarWidth >= 180 ? 20 : 12}px;
  border-right: 1px solid ${(props) => props.themeContext.borderColor || "#eee"};
  z-index: 2;
  background-color: ${props => props.themeContext.backgroundColor || "#fff"};
  height: calc(100vh - ${(props) => props.headerHeight}px);
`;
